import { useState } from 'react';
export function useTooltipContext() {
    var _a = useState(undefined), tooltipProps = _a[0], setTooltipProps = _a[1];
    return { tooltipProps: tooltipProps, setTooltipProps: setTooltipProps };
}
